import React, {Component} from 'react'
import Button from '../Button';
import './styles.scss';
import Registry from "../../../../registry";

class Select extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);

        let value = false;
        if (props.options.length != 0) {
            value = props.options[0].key;
        }
        for (let i in props.options) {
            if (props.options[i].key == props.value) {
                value = props.value;
            }
        }

        this.state = {value: value};
    }

    value() {
        return this.state.value;
    }

    onChange(event) {
        this.setState({value: event.target.value});
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    }

    renderOption(item) {
        return <option value={item.key} key={item.key}>{item.label}</option>
    }
    

    render() {
        if (this.props.ux == "buttons") return this.renderButtons();
        return (
        <div className="Select">
            <span className="label">{this.props.label}</span>
            <div className="wrapper">
                <select value={this.state.value} onChange={this.onChange}>
                    {
                        this.props.options.map(
                            (item, i) => this.renderOption(item))
                    }
                </select>
            </div>
        </div>);
    }


    onButtonClick(value) {
        return (event) => {
            event.preventDefault();

            this.setState({value}, () => {
                if (this.props.onChange) {
                    this.props.onChange(value);
                }
            })
        }
    }

    onMouseMove(e, key) {
        let tooltip = document.getElementById("show-room-tokens-select-tooltip");
        tooltip.classList.remove("b1", "b2", "b3", "b4", "b5");
        tooltip.classList.add("b" + key);
    }

    renderButton(item) {
        let title = item.label;
        let key = item.key;
        let button = item.button;
        let active = item.active;
        let value = item.value;

        if (!button) {
            return (<Button key={title} data-key={key} default={active} onClick={this.onButtonClick(value)} onMouseMove={(e) => this.onMouseMove(e, key)} text={title}/>);
        } else {
            let className="select-ux-button ";
            if (active) className += "active";
            return (<span key={key} data-key={key} className={className} onClick={this.onButtonClick(value)} onMouseMove={(e) => this.onMouseMove(e, key)}>{button}</span>);
        }
    }

    renderButtons() {
        let lang = Registry.get('locale');

        return (<div className="Select select-buttons">
            <span className="label">{this.props.label}</span>
            <input value={this.state.value} name={this.props.name} type="hidden"/>
            {this.props.options.map( (item) => {
                return this.renderButton({ active: item.value === this.state.value, ...item })
            }) }
            <div id="show-room-tokens-select-tooltip" className="select-buttons-tooltip" ref={(tooltip) => this.tooltip = tooltip} dangerouslySetInnerHTML={{__html:lang.showroom_price_buttons_tooltip}} />
        </div>)
    }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Select/index.js